export class FixAssetLookupZoneModel {
    id: string;
    name: string;
    code: string;
    sequence: number;
    type: string;
    location_id: string;
    color: string;
    icon: string;


    /**
     * Constructor
     *
     * @param asset
     */
    constructor(asset?)
    {
        asset = asset || {};
        this.color = asset.color
        this.icon = asset.icon;
        this.id = asset.id;
        this.location_id = asset.location_id;
        this.name = asset.name;
        this.code = asset.code;
        this.sequence = asset.sequence;
        this.type = asset.type;
    }    
}
